"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error.js";
import { useEffect } from "react";

const NextErrorComponent = NextError.default;

const GlobalError = ({ error }: { error: Error & { digest?: string } }) => {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextErrorComponent statusCode={0} />
      </body>
    </html>
  );
};

export default GlobalError;
